import { Component } from 'react';

export default class ColumnGroup extends Component {
  static isTableColumnGroup = true;
}
